import { UniversityService } from '../server/services/university.service';
import { CurrentUniversityService } from '../server/services/current-university.service';

export function universityDomainInitializer(universityService: UniversityService, currentUniversityService: CurrentUniversityService) {
	return () => {
		return new Promise<void>((resolve, reject) => {
			universityService.showUniversityWithDomain().subscribe({
				next: res => {
					currentUniversityService.currentUniversity = res.data;
					// currentUniversityService.changeUniversity(res.data);
					resolve(); // Risolve la Promise quando la chiamata è completata con successo
				},
				error: error => {
					resolve();
				},
			});
		});
	};
}
